import { getAuthCode } from "./getAuthCode";
export const createCustomPostFromText = async (SetIsError, SetErrorMessage,text,title,voice) => {
    try {
      const response = await fetch(process.env.REACT_APP_BACKEND_URL + "/createCustomPostFromText", {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body:JSON.stringify({auth_code:await getAuthCode(),text:text,title:title,voice:voice})
      });
     const result = await response.json();
      console.log("Status Code:", response.status);
      console.log("OK Status:", response.ok);
      if(response.ok){
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
        'event': 'post_created',
        });
      window.location.href = '/ideas?id=' + result.id;
      }
      else{
      SetIsError(true);
      SetErrorMessage(result.message);
      }
    } catch (error) {
      console.log(error);
    }
  };